export const isAdyenDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('saturn1000f2');
};
